/* eslint-disable */
import actionTypes from '../constants/actionTypes'
import fetchHelper from '../utils/fetchHelper'
import { message, Modal } from 'antd'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'
import desktopLib from '../utils/desktopLib'
import paymentConfig from '../constants/payment'

function parseMemberV2GoodsUI(goodsUI: any) {
  if (goodsUI == null || goodsUI === '') return {}
  if (typeof goodsUI === 'object') return goodsUI
  try {
    return JSON.parse(goodsUI)
  } catch {
    return {}
  }
}

function memberV2GoodsUIToLegacyContent(ui: any) {
  const t = (v: any) => (typeof v === 'string' ? v.trim() : '')
  const displayName = t(ui.displayName)
  const webDescription = t(ui.webDescription)
  const topBadge = t(ui.topBadgeText)
  const bottomText = t(ui.bottomText)
  const fakeName = t(ui.fakeCouponName)
  const fakeVal = t(ui.fakeCouponValue)

  const title = displayName || t(ui.title) || '团队会员'
  const subTitle = webDescription

  let sign = topBadge
  if (!sign && fakeName) {
    sign = fakeName + (fakeVal || '')
  }
  if (!sign) {
    sign = t(ui.sign)
  }

  const footer = bottomText || t(ui.footer) || ''

  return { title, subTitle, sign, footer }
}

function inferMonthCntFromVipType(vipType: number) {
  const pt = paymentConfig.paymentType
  if (vipType === pt.singleMonth || vipType === pt.multipleMonth) return 1
  if (vipType === pt.periodQuarter) return 3
  if (vipType === pt.twoYear) return 24
  return 12
}

function resolveMemberV2VipType(sku: any) {
  const isPeriod = Number(sku.isPeriod) === 1
  const spu = Number(sku.spuType)
  if (spu === 9 && isPeriod) {
    return paymentConfig.paymentType.periodQuarter
  }
  if (isPeriod) {
    return paymentConfig.paymentType.multipleYear
  }
  return paymentConfig.paymentType.singleYear
}

function mapMemberV2SkuToGoodsItem(sku: any, groupVipKind: number) {
  const ui = parseMemberV2GoodsUI(sku.goodsUI)
  const text = memberV2GoodsUIToLegacyContent(ui)
  const vipType = resolveMemberV2VipType(sku)
  const monthCnt =
    typeof ui.monthCnt === 'number' && ui.monthCnt > 0
      ? ui.monthCnt
      : inferMonthCntFromVipType(vipType)
  const isSub = Number(sku.isPeriod) === 1
  return {
    id: String(sku.skuID),
    price: sku.price,
    type: isSub ? 2 : 1,
    content: {
      ...text,
      vipType,
      vipKind: groupVipKind,
      pricePerMonth: sku.perMonthPrice,
      monthCnt
    }
  }
}

function normalizeGroupMemberV2GoodsResponse(data: any) {
  const payload = data.payload
  if (!payload || !Array.isArray(payload.goodsList)) {
    if (Array.isArray(data.goods)) return data
    return { ...data, goods: [] }
  }
  const goods: any[] = []
  payload.goodsList.forEach((group: any) => {
    const vk = group.vipKind
    if (group.items && Array.isArray(group.items)) {
      group.items.forEach((sku: any) => {
        if (sku != null && sku.skuID != null) {
          goods.push(mapMemberV2SkuToGoodsItem(sku, vk))
        }
      })
    }
  })
  return {
    ...data,
    goods,
    memberV2Kind: payload.kind,
    memberV2StrategyID: payload.strategyID
  }
}

export function fetchGoodList(data: any) {
  return (dispatch: any, getState: any) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    const config = {
      url: __API_SERVER_HOST__ + '/web/goods/group/member/v2',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          Object.assign(
            {
              groupID:
                data.groupID != null ? String(data.groupID) : data.groupID,
              appType: 4
            },
            data.userID != null && data.userID !== ''
              ? { userID: String(data.userID) }
              : {}
          )
        )
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data: any) => {
        return Promise.resolve(normalizeGroupMemberV2GoodsResponse(data))
      })
      .catch((err: any) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function createPaymentOrder(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    const clientInfo = desktopLib.isDesktop
      ? {
          'Client-Info': 'windows,1.0.0'
        }
      : null
    let config = {
      url: __API_SERVER_HOST__ + '/web/order/create',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...clientInfo
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function createBatchPaymentOrder(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    const clientInfo = desktopLib.isDesktop
      ? {
          'Client-Info': 'windows,1.0.0'
        }
      : null
    let config = {
      url: __API_SERVER_HOST__ + '/web/order/create/v2',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...clientInfo
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function fetchPaymentOrderStatus(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/order/query',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 补差价接口
export function fetchUpdateGoodsInfo(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/order/update/good/info',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

/** 积分加量包充值下单（AI 问照片等积分业务） */
export function rechargeAgentPoints(data: any) {
  return (dispatch: any, getState: any) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/agent/recharge',
      arguments: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
  }
}
